<template>
  <div class="items-wrap">
    <div class="public-breadcrumb">
      {{ $t("Welcome") }} > {{ $t("lcd.material.materialManage") }} >
      <span style="color: #3461ff">{{
        $t("lcd.material.merchantMaterial")
      }}</span>
    </div>
    <div class="top">
      <div class="left">
        <el-button
          icon="el-icon-upload2"
          class="more-btn"
          size="small"
          @click="uploadFun"
          v-if="activeName != 'third'"
        >
          <span>{{ $t("lcd.material.MaterialUpload") }}</span>
        </el-button>
        <el-button
          icon="el-icon-plus"
          class="more-btn"
          size="small"
          @click="addPricetagClick({}, 'add')"
          v-if="activeName == 'third'"
        >
          <span>{{ $t("lcd.material.Add") }}</span>
        </el-button>
      </div>
      <div class="right">
        <el-select
          v-model="pageParams.state"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          :placeholder="$t('lcd.material.Please select material status')"
          v-if="activeName != 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in stateList"
            :key="item.codeValue"
            :label="item.codeName"
            :value="item.codeValue"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="pageParams.materialType"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          :placeholder="$t('lcd.material.Please Select Material Type')"
          v-if="activeName != 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in formatList"
            :key="item.codeValue"
            :label="item.codeName"
            :value="item.codeValue"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="pageParams.pixels"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          :placeholder="$t('lcd.material.Please Select Material Type')"
          @change="getList"
          v-if="activeName != 'third'"
        >
          <el-option
            v-for="item in pixelsList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="templatePageParams.activeState"
          style="width: 150px; margin: 0 10px 0 0"
          size="small"
          clearable
          :placeholder="
            $t('lcd.material.Please select template publish status')
          "
          v-if="activeName == 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in activeStateList"
            :key="item.codeValue"
            :label="item.codeName"
            :value="item.codeValue"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="templatePageParams.templateSize"
          :placeholder="$t('lcd.Template.Please Select Template Resolution')"
          allow-create
          clearable
          size="small"
          style="width: 150px; margin: 0 10px 0 0"
          ref="resolutionRef"
          @clear="clearResolution"
          v-if="this.activeName == 'third'"
          @change="getList"
        >
          <el-option
            v-for="item in priceTagSizeList()"
            :key="item.id"
            :label="item.label"
            :value="item.value"
            @click.native="opClick"
          >
          </el-option>
          <el-option
            label="0"
            value="0"
            disabled
            style="height: 40px; line-height: 40px; cursor: default"
          >
            <el-input
              v-model="customResolution.width"
              controls-position="right"
              :max="1280"
              size="mini"
              placeholder="宽"
              type="number"
              style="width: 60px"
              class="resolutionInput"
            ></el-input>
            <el-input
              v-model="customResolution.height"
              controls-position="right"
              :max="1280"
              size="mini"
              type="number"
              placeholder="高"
              style="width: 60px"
              class="resolutionInput"
            ></el-input>
            <el-button
              @click="resolutionConfirm"
              style="
                padding: 0 15px;
                height: 28px;
                line-height: 26px;
                font-size: 12px;
                border-radius: 4px;
                float: right;
                margin-top: 7px;
              "
              >确定</el-button
            >
          </el-option>
        </el-select>
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          ref="search-val"
          style="width: 160px"
          :placeholder="$t('lcd.material.Please Input Material Name')"
          v-model="pageParams.materialName"
          @change="getList"
          v-if="activeName != 'third'"
        />
        <el-input
          clearable
          prefix-icon="el-icon-search"
          size="small"
          ref="search-val"
          style="width: 160px"
          :placeholder="$t('lcd.material.Please Input Material Name')"
          v-model="templatePageParams.templateName"
          @change="getList"
          v-if="activeName == 'third'"
        />
      </div>
    </div>
    <div class="center">
      <div class="center-title">
        <el-button
          class="allSelectBtn"
          v-if="multipleSelect && tableList.length > 0"
          size="small"
          @click="allSelectClick"
          >{{
            selectionList.length < tableList.length
              ? $t("lcd.material.Select All")
              : $t("lcd.material.Select None")
          }}</el-button
        >
        <span class="number"
          >{{ $t("itemsScenarios.Record") }}: {{ tableInfo.total }}</span
        >
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        style="padding: 0 20px"
      >
        <el-tab-pane
          :label="$t('lcd.material.ItemMaterial')"
          name="first"
        ></el-tab-pane>
        <el-tab-pane
          :label="$t('lcd.material.MarketMaterial')"
          name="second"
        ></el-tab-pane>
        <el-tab-pane
          :label="$t('lcd.material.PriceTag')"
          name="third"
        ></el-tab-pane>
      </el-tabs>
      <div style="padding: 0 20px">
        <el-row :gutter="18">
          <el-col
            :xs="12"
            :sm="8"
            :md="8"
            :lg="6"
            :xl="4"
            v-for="o in tableList"
            :key="o.id"
            style="margin-bottom: 18px"
          >
            <el-card
              class="elCard"
              shadow="hover"
              :body-style="{ padding: '0px' }"
            >
              <!-- <el-checkbox
                class="checkboxCard"
                :value="o.materialId"
                v-if="multipleSelect"
                :checked="selectionList.indexOf(o.materialId) > -1"
                @change="ids(o.materialId)"
              ></el-checkbox> -->
              <span
                class="selectStates"
                :class="
                  selectionList.indexOf(o.materialId) > -1
                    ? 'selectedState'
                    : 'noSelected'
                "
                v-if="multipleSelect"
                @click="ids(o.materialId)"
              >
                <i class="checkIcon el-icon el-icon-check"></i>
              </span>
              <span class="format">{{ o.format || o.templateSize }}</span>
              <div style="width: 100%; padding: 8px 10px; position: relative">
                <span class="auditSpan" v-if="o.state == 0">
                  {{ $t("lcd.material.To Audit") }}
                </span>
                <span
                  class="auditSpan"
                  v-if="o.state == 2"
                  style="background-color: #fef0f0; color: #f56c6c"
                >
                  {{$t('lcd.material.Audit No')}}
                </span>
                <span
                  class="auditSpan"
                  v-if="o.state == 3"
                  style="background-color: #fdf6ec; color: #e6a23c"
                >
                  转换中
                </span>
                <span
                  class="auditSpan"
                  v-if="o.openType == 3"
                  style="background-color: #fdf6ec; color: #e6a23c"
                >
                  系统价签模板
                </span>
                <span
                  class="auditSpan"
                  v-if="o.openType == 3"
                  style="background-color: #fdf6ec; color: #e6a23c"
                >
                  门店价签模板
                </span>
                <div
                  class="materialWrap"
                  @click="imgClick(o)"
                  :style="{
                    cursor: 'pointer',
                    'min-height': '120px',
                    height: imgWidth + 'px',
                    'background-image': 'url(' + o.originalUrl + ')',
                    'background-size': 'contain',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat',
                  }"
                  v-if="activeName != 'third'"
                >
                  <video
                    @click="imgClick(o)"
                    v-if="o.format == 'mp4'"
                    :style="{
                      'max-width': '100%',
                      'max-height': imgWidth + 'px',
                      'min-height': '120px',
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                    }"
                    :src="o.originalUrl"
                  ></video>
                  <!-- <el-image
                    :src="o.originalUrl"
                    class="materialImage"
                    @click="imgClick(o)"
                    fit="contain"
                    v-else
                    :style="{
                      'max-width': '100%',
                      'max-height': imgWidth + 'px',
                      width: 'auto',
                      height: 'auto',
                      'min-width': '100%',
                      'min-height': '100%',
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                    }"
                  >
                    <div slot="error" class="image-slot">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image> -->
                </div>
                <div
                  class="materialWrap"
                  @click="imgClick(o)"
                  :style="{
                    cursor: 'pointer',
                    'min-height': '120px',
                    height: imgWidth + 'px',
                    'background-image':
                      'url(' + o.templateImageUrlList[0] + ')',
                    'background-size': 'contain',
                    'background-position': 'center',
                    'background-repeat': 'no-repeat',
                  }"
                  v-else
                ></div>
              </div>
              <div class="imageName">
                <span>{{ o.materialName || o.templateName }}</span>
                <el-button
                  class="copyButton"
                  circle
                  plain
                  icon="el-icon-s-check"
                  type="danger"
                  title="审核"
                  v-if="o.state == 0"
                  @click="openAuditDialog(o)"
                ></el-button>
              </div>
              <div class="templateBtnList">
                <!-- 商品素材及营销素材编辑 -->
                <el-button
                  class="templateBtn"
                  :title="$t('button.Edit')"
                  circle
                  plain
                  icon="el-icon-edit"
                  v-if="activeName != 'third'"
                  @click="editClick(o)"
                ></el-button>
                <!-- 价签列表编辑 -->
                <el-button
                  class="templateBtn"
                  :title="$t('button.Edit')"
                  circle
                  plain
                  icon="el-icon-edit"
                  v-if="activeName == 'third'"
                  @click="templateClick(o)"
                ></el-button>
                <el-button
                  class="templateBtn"
                  :title="$t('button.Copy')"
                  v-if="activeName == 'third'"
                  @click="addPricetagClick(o, 'copy')"
                  circle
                  plain
                  icon="el-icon-copy-document"
                ></el-button>
                <!-- 
                  o.activeState
                  模板发布状态
                  0 待发布
                  1 已发布
                -->
                <el-button
                  class="templateBtn"
                  title="发布"
                  plain
                  circle
                  icon="el-icon-position"
                  v-if="o.activeState == 5301"
                  @click="handlePublish(o)"
                ></el-button>

                <!-- {{o.openType}} -->
                <el-button
                  class="templateBtn"
                  title="删除"
                  type="danger"
                  circle
                  plain
                  icon="el-icon-delete"
                  v-if="
                    o.createUser == userData.username ||
                    o.createUser == userData.loginId ||
                    o.storeId == storeId
                  "
                  @click="handelDelete(o)"
                ></el-button>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div v-if="tableList.length < 1">
        <el-empty
          :image-size="200"
          :description="this.$t('lcd.noData')"
        ></el-empty>
      </div>
      <pagination :tableInfo="tableInfo" @changePage="changePage" />
    </div>
    <!-- 操作确认弹窗 -->
    <confirm-dialog
      :dialogVisible="isVisibleConfirmDialog"
      @handleClose="handelConfirmDialog"
      :confirmObj="confirmObj"
    >
    </confirm-dialog>

    <!-- 创建素材 -->
    <create-img ref="createImg" :editData="editData" @getData="getData">
    </create-img>
    <edit-img ref="editImg" :editData="editData" @getData="getData"> </edit-img>

    <!-- 素材预览弹窗 -->
    <preview-dialog
      :dialogVisible="previewVisible"
      @handleClose="handleClosePreview"
      :previewObj="previewObj"
    ></preview-dialog>

    <!-- 素材审核弹窗 -->
    <audit-dialog
      :dialogVisible="auditVisible"
      @handleClose="handleCloseAudit"
      @reGetList="reGetList"
      :auditObj="auditObj"
    ></audit-dialog>

    <!-- 素材批量审核 -->
    <batch-audit
      :dialogVisible="batchAuditVisible"
      @handleClose="handleCloseBatchAudit"
      @reGetList="reGetList"
      :selectionList="selectionList"
    ></batch-audit>

    <!-- 新建/复制价签模板弹窗 -->
    <AddPriceTag
      :flag="flag"
      :editData="currentRow"
      ref="addPricetagRef"
      @reGetList="reGetList"
    >
    </AddPriceTag>

    <!-- 价签预览弹窗 -->
    <preview-template
      :dialogVisible="previewTemplateVisible"
      @handleClose="handleClosePreviewTemplate"
      :previewObj="previewObj"
    ></preview-template>
  </div>
</template>
<script>
import { RepeatIcon, ShieldOffIcon } from "vue-feather-icons";
import pagination from "@/components/pagination";
import ConfirmDialog from "@/components/confirm-dialog/index.vue";
import CreateImg from "../components/createImg.vue";
import EditImg from "../components/editImg.vue";
import PreviewDialog from "../components/preview.vue";
import PreviewTemplate from "../components/previewTemplate.vue";

import AuditDialog from "../components/auditDialog.vue";
import AddPriceTag from "../components/addPriceTag.vue";
import { getCodeList } from "@/libs/api/aps"; // 获取下拉列表list接口
import {
  getMaterialList,
  getPixels,
  deleteMaterial,
  getTemplateList,
  getTemplateInfo,
  createInfo,
  updateInfo,
  copyInfo,
  activeInfo,
  unActiveInfo,
  saveJson,
  deleteInfo,
  getMaterialDetail,
} from "@/libs/api/lcd";
import BatchAudit from "../components/batchAudit.vue";
import { priceTagSizeList } from "@/libs/enum";
// import {
//     checkPerm,
//     checkRole
// } from "@/utils/permission"; // 权限判断函数

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      storeId: localStorage.getItem("storeId"),
      priceTagSizeList,
      multipleSelect: true,
      selectionList: [], // 多选数据
      activeName: "first",
      pageParams: {
        materialName: "",
        isEffect: "0",
        openType: "0,1,2,4",
        materialType: "",
        state: "",
        pixels: "",
        current: "1",
        size: "10",
      },
      initPageParams: {
        materialName: "",
        isEffect: "0",
        openType: "0,1,2,4",
        materialType: "",
        state: "",
        pixels: "",
        current: "1",
        size: "10",
      },
      templatePageParams: {
        templateGroupId: "0", // 0：价签模板 1：营销模板
        templateName: "", // 模板名称
        templateSize: "", // 分辨率
        usageState: "", // 使用状态 (已使用/未使用）
        activeState: "", // 激活状态(待发布5301/已发布5302)
        current: "1",
        size: "10",
        openType: "0,1,2,4",
      },
      initTemplatePageParams: {
        templateGroupId: "0", // 0：价签模板 1：营销模板
        templateName: "", // 模板名称
        templateSize: "", // 分辨率
        usageState: "", // 使用状态 (已使用/未使用）
        activeState: "", // 激活状态(待发布5301/已发布5302)
        current: "1",
        size: "10",
        openType: "0,1,2,4",
      },
      previewVisible: false,
      previewObj: {},
      imgWidth: 0,
      editData: {},
      stateList: [], // 素材审核状态list
      formatList: [], // 图片格式类型
      pixelsList: [],
      currentRow: {}, // 当前操作的对象
      flag: "add",
      auditVisible: false, // 审核弹窗可见性
      auditObj: {}, //  审核弹窗数据
      batchAuditVisible: false, // 批量审核弹窗
      isVisibleConfirmDialog: false, // 确认弹窗可见性
      confirmObj: {
        type: this.$t("devices.tips"),
        cancelText: this.$t("devices.cancel"),
        confirmText: this.$t("devices.sure"),
        content: this.$t("devices.esl.repushTips"),
        loading: false,
      },
      currentConfirmType: "",
      loading: true,
      tableInfo: {
        current: 1,
        size: 10,
        total: 0,
      },
      tableList: [], // item 表格list
      storeType: "2",
      storeOption: [
        { id: "2", value: this.$t("itemsScenarios.ThisStore") },
        { id: "4", value: this.$t("itemsScenarios.LastStore") },
        { id: "1", value: this.$t("itemsScenarios.ZimenStore") },
        { id: "0", value: this.$t("itemsScenarios.AllStore") },
      ], // 商店list
      visible: false,
      multipleSelection: [],
      init: true, // 是否首次进入页面
      activeStateList: [], // 模板发布状态emun list
      customResolution: {},
      previewTemplateVisible: false,
    };
  },
  components: {
    RepeatIcon,
    ShieldOffIcon,
    CreateImg,
    EditImg,
    PreviewDialog,
    PreviewTemplate,
    AuditDialog,
    AddPriceTag,
    pagination,
    ConfirmDialog,
    BatchAudit,
  },
  computed: {
    language() {
      return this.$store.state.appConfig.language;
    },
  },
  watch: {
    // storeType: {
    //   handler(val) {
    //     this.initItemList();
    //   },
    // },
  },
  mounted() {
    // commonStore.setInjectCallBack(this.initPage);
    // this.setImgHeight();
    this.getPixelList();
    this.getEnum(39);
    this.getEnum(40);
    this.getEnum(41);
    this.getEnum(53);
    this.getList();
    setTimeout(() => {
      this.setImgHeight();
    }, 500);
  },
  methods: {
    async getEnum(id) {
      const params = {
        cateId: id,
      };
      try {
        const { data } = await getCodeList(params);
        if (data.state === true) {
          let arr = data.data || [];
          if (id == 39) {
            this.stateList = arr; // 素材审核状态list
          } else if (id == 40) {
            this.groupList = arr; // 素材分组list
          } else if (id == 41) {
            this.formatList = arr; // 图片格式类型list
          } else if (id == 53) {
            this.activeStateList = arr; // 发布状态类型list
          }
        } else {
          this.$message.error(data.message);
        }
      } catch (err) {
        const { message } = err;
        this.$message.error(message);
      }
    },
    // 获取像素筛选项列表
    getPixelList() {
      getPixels().then((res) => {
        console.log(res);
        this.pixelsList = res.data.data;
      });
    },
    getList() {
      // TODO 获取数据
      this.selectionList = [];
      this.tableList = [];
      if (this.activeName != "third") {
        // 获取素材列表
        const params = {
          ...this.pageParams,
          current: this.tableInfo.current,
          size: this.tableInfo.size,
          groupId: this.activeName == "first" ? "0" : "1",
        };
        getMaterialList(params).then((res) => {
          console.log(res);
          this.tableList = res.data.data.records;
          this.tableInfo.total = res.data.data.total;
        });
      } else {
        // 获取价签列表
        const params = {
          ...this.templatePageParams,
          current: this.tableInfo.current,
          size: this.tableInfo.size,
          storeId: localStorage.getItem("storeId"),
        };
        getTemplateList(params).then((res) => {
          console.log(res);
          res.data.data.records.forEach((item) => {
            item.templateImageUrlList = item.templateImageUrl
              ? item.templateImageUrl.split(",")
              : [];
          });
          this.tableList = res.data.data.records;
          console.log(this.tableList);
          this.tableInfo.total = res.data.data.total;
        });
      }
    },
    // 翻页
    changePage() {
      this.getList();
    },
    setImgHeight() {
      let el = document.getElementsByClassName("materialWrap")[0];
      console.log(el);
      this.imgWidth = el ? el.offsetWidth : "120";
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.pageParams = this.initPageParams;
      this.getList();
    },
    imgClick(obj) {
      // TODO
      console.log(123);
      console.log(this.activeName);
      
      if (this.activeName == "third") {
        this.previewObj = obj;
        this.previewVisible = false;
        this.previewTemplateVisible = true;
      } else {
        const params = {
          materialId: obj.materialId
        }
        getMaterialDetail(params).then(res => {
          console.log(res)
          this.previewObj = res.data.data;
          this.previewVisible = true;
          this.previewTemplateVisible = false;
        })
        
      }
    },
    handleClosePreview() {
      this.previewObj = {};
      this.previewVisible = false;
    },

    handleClosePreviewTemplate() {
      this.previewObj = {};
      this.previewTemplateVisible = false;
    },

    // 上传和编辑素材
    uploadFun() {
      this.editData = {};
      this.$refs.createImg.open();
    },
    getData() {
      // TODO 上传、修改完成后需要重新获取列表数据
      console.log(123);
      this.getList();
    },
    // 编辑素材
    editClick(row) {
      this.editData = row;
      this.$refs.editImg.open();
    },

    handelDelete(row) {
      this.currentRow = row;
      this.confirmObj.content =
        this.activeName == "third"
          ? this.$t("lcd.material.Comfirm Delete PriceTag") +
            `${row.templateName}`
          : this.$t("lcd.material.Comfirm Delete Material") +
            `${row.materialName}`;
      this.isVisibleConfirmDialog = true;
      this.currentConfirmType = "materialDelete";
    },

    doDelete() {
      console.log("handelDelete");
      if (this.activeName != "third") {
        // 删除素材
        const params = {
          materialId: this.currentRow.materialId,
        };
        deleteMaterial(params).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(this.$t("devices.deleteSuccess"));
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
          this.confirmObj.loading = false;
          this.isVisibleConfirmDialog = false;
        });
      } else {
        // 删除价签模板
        console.log("templateDelete");
        const params = {
          templateId: this.currentRow.templateId,
        };
        console.log(params);
        deleteInfo(params).then((res) => {
          console.log(res);
          if (res.data.code == 1) {
            this.$message.success(this.$t("devices.deleteSuccess"));
            this.getList();
          } else {
            this.$message.error(res.data.message);
          }
          this.confirmObj.loading = false;
          this.isVisibleConfirmDialog = false;
        });
      }
    },

    handelConfirmDialog(val) {
      console.log(val);
      if (val === "confirm") {
        const { currentConfirmType } = this;

        this.confirmObj.loading = true;
        if (currentConfirmType === "materialDelete") {
          // 素材删除
          this.doDelete();
        }
      } else {
        this.isVisibleConfirmDialog = false;
        this.confirmObj.loading = false;
      }
    },

    // 素材审核相关

    openAuditDialog(row) {
      this.auditObj = row;
      this.auditVisible = true;
    },
    handleCloseAudit() {
      this.auditObj = {};
      this.auditVisible = false;
    },
    openBatchAuditDialog() {
      this.batchAuditVisible = true;
    },
    handleCloseBatchAudit() {
      // this.selectionList = [];
      this.batchAuditVisible = false;
    },
    reGetList() {
      this.auditObj = {};
      this.auditVisible = false;
      this.batchAuditVisible = false;
      this.selectionList = [];
      this.getList();
    },

    // 素材列表多选功能
    indexOf(val, ids) {
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] == val) {
          return i;
        }
      }
      return -1;
    },
    // ids
    ids(id) {
      let index = this.indexOf(id, this.selectionList);
      if (this.selectionList.length > 0 && index > -1) {
        this.selectionList.splice(index, 1);
      } else {
        this.selectionList.push(id);
      }
    },
    allSelectClick() {
      // console.log(this.selectionList.length)
      // console.log(this.tableList.length)
      if (this.selectionList.length < this.tableList.length) {
        this.selectionList = [];
        this.tableList.map((item) => {
          this.selectionList.push(item.materialId);
        });
      } else {
        this.selectionList = [];
        console.log("取消");
      }
    },

    /***
     * priceTag template
     * 价签模板相关
     * **/
    clearResolution() {
      this.customResolution = {
        width: "",
        height: "",
      };
    },
    opClick() {
      this.customResolution = {
        width: "",
        height: "",
      };
    },
    // 自定义素材分辨率确认
    resolutionConfirm() {
      let resolutionRef = this.$refs.resolutionRef;
      console.log(resolutionRef);
      resolutionRef.visible = false;
      this.templatePageParams.templateSize =
        this.customResolution.width > 0 && this.customResolution.height > 0
          ? this.customResolution.width + "*" + this.customResolution.height
          : "";
      if (this.customResolution.width > 0 && this.customResolution.height > 0) {
        this.getList();
      }
    },
    // 编辑模板
    templateClick(row) {
      console.log(row);
      const query = {
        templateId: row.templateId,
      };
      const params = {
        templateId: row.templateId,
      };
      getTemplateInfo(params).then((res) => {
        console.log(res.data.data.svgValue);
        // JSON.stringify(res.data.data)
        localStorage.setItem("templateInfo", res.data.data.svgValue);
        const toEditor = this.$router.resolve({
          path: `/editor`,
          query: query,
        });
        console.log(toEditor);
        window.open(toEditor.href, "_blank");
      });
    },
    // 新建价签模板

    addPricetagClick(data, flag) {
      this.currentRow = {};
      this.flag = flag;
      this.currentRow = data;
      this.$refs.addPricetagRef.open();
    },

    handlePublish(row) {
      console.log(row);
      const params = {
        templateId: row.templateId,
      };
      activeInfo(params).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          this.$message.success(this.$t("lcd.Template.Publish Success"));
          this.getList();
        } else {
          this.$message.error(this.$t("lcd.Template.Publish Error"));
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

.items-wrap {
  .top {
    height: 70px;
    padding: 20px;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    margin-bottom: 20px;
    background: #fff;
    .left {
      float: left;
      .new-btn,
      .update-btn,
      .more-btn,
      .delete-btn {
        border-radius: 6px;
        color: #fff;
        position: relative;
        padding: 9px 15px;
      }
      // .el-icon-check,.el-icon-delete{
      //   position: absolute;
      //   left: 20px;
      // }
      .new-btn {
        width: 85px;
        background: #3461ff;
      }
      .update-btn {
        // width: 190px;
        background: #3461ff;
      }
      .more-btn {
        // width: 140px;
        background: #3461ff;
      }
      .delete-btn {
        // width: 135px;
        background: #fc174d;
      }
    }
    .right {
      float: right;
      .import-btn,
      .export-btn,
      .share-btn {
        background: #eeeeee;
        border: 1px solid #eeeeee;
        border-radius: 6px;
        color: #666666;
      }
      .import-btn,
      .export-btn,
      .share-btn {
        width: 80px;
      }
    }
  }
  .center {
    position: relative;
    background: #fff;
    box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    // padding: 16px 28px;
    .refresh {
      background: #35b871;
      border: none;
      padding: 6px 8px;
      border-radius: 4px;
      color: #fff;
      float: right;
      margin-right: 10px;
    }
    ::v-deep .el-popover {
      position: absolute;
      right: 20px;
      width: 100px;
      height: 150px;
      cursor: pointer;
    }
    .center-title {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 3;
      padding: 13px 20px;
      .number {
        font-size: 12px;
      }
    }
    ::v-deep .el-table {
      .is-group tr:nth-child(2) .el-checkbox {
        display: none;
      }
      .is-group tr:last-child .el-checkbox {
        display: none;
      }
      .date-cell {
        width: 350px;
        .el-date-editor {
          width: 140px;
        }
      }
      .el-icon-help,
      .el-icon-edit {
        font-size: 18px;
        width: 14px;
        cursor: pointer;
      }
      .el-icon-edit {
        margin: 0 17px;
      }
      .el-table__cell {
        text-align: center;
      }
    }
  }
}

// #35B871
.elCard {
  position: relative;
  .materialWrap {
    width: 100%;
    overflow: hidden;
    position: relative;
    // background-color: #f5f5f5;
  }
  .materialImage,
  .materialVideo {
    // max-width: 100%;
    // max-height: 100%;
    width: auto;
    height: auto;
    cursor: pointer;
    // left: 50%;
  }
  .format {
    position: absolute;
    top: 5px;
    right: 5px;
    min-width: 40px;
    text-align: center;
    padding: 2px 8px;
    border-radius: 16px;
    z-index: 11;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .imageInfo {
    line-height: 12px;
    padding: 3px 10px 0;
    position: relative;
    color: #c2c2c2;
    font-size: 12px;
  }
  .imageName {
    line-height: 16px;
    font-size: 13px;
    height: 36px;
    padding: 2px 40px 2px 10px;
    text-align: justify;
    display: flex;
    align-items: center;
    position: relative;
    // background-color: pink;
    .copyButton {
      position: absolute;
      right: 10px;
      bottom: 5px;
      padding: 0;
      padding: 4px;
      font-size: 12px;
    }
  }
}
.elCard:hover {
  border: 1px solid #1dd670;
}
::v-deep .el-popper .popper__arrow::after {
  border-right-color: red !important;
}
::v-deep .el-popover__reference {
  display: flex !important;
  align-items: center !important;
}
::v-deep .el-table--border,
.el-table--group {
  border: none !important;
}
::v-deep .el-textarea__inner {
  height: 34px;
}
::v-deep .el-button + .el-button {
  margin: 0;
}
.materialImage ::v-deep .el-image__error,
.el-image__inner,
.el-image__placeholder {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: aoto;
}
.templateBtnList {
  display: flex;
  justify-content: space-between;
  padding: 1px 10px 8px;
  .templateBtn {
    padding: 4px;
    font-size: 12px;
  }
}
.auditSpan {
  padding: 5px 8px;
  background-color: #ecf5ff;
  color: #409eff;
  position: absolute;
  border-radius: 4px 0 0 4px;
  right: 0;
  bottom: 0;
  z-index: 2;
  font-size: 12px;
}
.checkboxCard {
  position: absolute;
  top: 10px;
  left: 10px;
  ::v-deep .el-checkbox__inner {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
  }
  ::v-deep .el-checkbox__inner::after {
    left: 6px;
    top: 2px;
  }
}
.allSelectBtn {
  padding: 5px 10px;
  font-size: 12px;
  margin-right: 12px;
}
.selectStates {
  width: 18px;
  height: 18px;
  position: absolute;
  top: 10px;
  left: 10px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  background-color: #fff;
  cursor: pointer;
  z-index: 2;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  &:hover {
    border: 1px solid #3461ff;
  }
}
.selectedState {
  background-color: #3461ff;
  border: 1px solid #3461ff;

  .checkIcon {
    color: #fff;
  }
}
.resolutionInput {
  margin-right: 12px;
  ::v-deep .el-input__inner {
    border: none !important;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
  }
}
</style>
